import {Component, OnInit, Input} from '@angular/core';
import {NgbActiveModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {LogService} from '../../services/log.service';
import {Log} from '../../model/log';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BranchesShowComponent} from '../../views/setting/branches/branches-show/branches-show.component';
import {TranslateService} from "@ngx-translate/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {validate} from "codelyzer/walkerFactory/walkerFn";
import {ItemsGroup} from "../../views/setting/itemsGroups/itemsGroups";
import {User} from "../../model";
import {UserService} from "../../services/user.service";
import {Message} from "primeng/api";
import {Router} from "@angular/router";
import {UserProfileComponent} from "../user-profile/user-profile.component";
import {UserPictureComponent} from "../user-picture";
import {appConfig} from "../../app.config";
import {email} from "ng4-validators/src/app/email/validator";

@Component({
    selector: 'app-user-settings',
    templateUrl: './user-settings.component.html',
    styleUrls: ['./user-settings.component.scss'],
    providers: []
})
export class UserSettingsComponent implements OnInit {
    id: string;
    public user: User;
    userData: any;
    public logs: Log[];
    oldPass: any;
    emilForm: FormGroup;
    msgs: Message[] = [];
    @Input() rowId;
    @Input() refShow;
    modalRef: NgbModalRef;
    form: FormGroup;
    public fullurl = '';
    public imgUrl = appConfig.publicUrl;
    emailErr: boolean = false;
    emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
    auth = [{'val': 0, 'title': 'None'}, {'val': 1, 'title': 'Email'}, {'val': 2, 'title': 'Mobile'}];


    constructor(public activeModal: NgbActiveModal,
                public logService: LogService,
                private router: Router,
                private userService: UserService,
                public translate: TranslateService,
                private formBuilder: FormBuilder,
                private modalService: NgbModal,) {
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (userdata) {
            this.id = userdata.id;
            this.oldPass = userdata.password;
            this.changePicUrl();
        }

        console.log(this.user);
    }

    ngOnInit() {
      //  this.changePicUrl();

        this.form = this.formBuilder.group({

            name: new FormControl({value: ''}, Validators.required),
            email: new FormControl({value: ''},Validators.pattern(this.emailPattern)),
            tel: new FormControl({value: ''}),
            mobile: new FormControl({value: ''}),
            two_factor_authentication: new FormControl('0'),

            picture: new FormControl({value: ''},Validators.required)

        });
        if (this.id) {
            // this.activeModal.dismiss('');
            // localStorage.removeItem('filter');
          /*  const msg = JSON.parse(localStorage.getItem('showMessages'));
            if (msg) {
                localStorage.removeItem('showMessages');
                this.msgs = msg;
            }*/
            this.userService.getById(this.id).subscribe(
                user => {
                    this.id = user.id;
                    this.user = user;
                    this.form.patchValue({
                        name: user.name,
                        email: user.email,
                        tel: user.tel,
                        mobile: user.mobile,
                        two_factor_authentication: user.two_factor_authentication,

                    });
                }, error => {
                    console.log(error);
                }
            );


        }
        /*   this.logService.getAll(this.rowId).subscribe(
             logs => {
               this.logs = logs;
             },
             err => {
               console.log(err);
             }

           );*/
    }

    onSubmit() {
        if (this.form.valid) {
          /*  if(this.form.hasError('email') && this.form.get('email').touched){
                this.msgs = [];
                this.msgs.push({
                    severity: 'success',
                    summary: '',
                    detail: this.translate.instant('Not valid Email format')
                });
            }*/
            let user: User = new User();
            user.id=this.id;
            user.name = this.form.controls['name'].value;
            user.email = this.form.controls['email'].value;
            user.tel = this.form.controls['tel'].value;
            user.mobile = this.form.controls['mobile'].value;
            user.two_factor_authentication = this.form.controls['two_factor_authentication'].value;


              this.userService.updateProfile(user).subscribe(
                  ruser => {
                      //this.id = ruser.id;
                      this.msgs = [];
                      if(ruser.result){
                          this.form.controls['email'].reset();
                          this.msgs.push({severity: 'error', summary: '', detail: this.translate.instant(ruser.message)});
                         // this.id = ruser.id;
                      }else{
                      this.msgs.push({
                          severity: 'success',
                          summary: '',
                          detail: this.translate.instant('Edit completed successfully')
                      });}
                     // this.form.reset();
                      localStorage.setItem('showMessages', JSON.stringify(this.msgs));
/*
                      this.router.navigate(['/users/show', this.id]);
*/
                  }, error => {
                      console.log(error);
                  }
                    );


        } else {
            if(this.form.controls.email.dirty && this.form.controls['email'].value !== ""){
                this.msgs = [];
                this.msgs.push({
                    severity: 'error',
                    summary: '',
                    detail: this.translate.instant('email-validation')
                });
                this.emailErr = true;

                // this.validateAllFormFields(this.form)
            }else{
                this.msgs = [];
                this.msgs.push({
                    severity: 'error',
                    summary: '',
                    detail: this.translate.instant('Please fill inputs with red border')
                });
                this.validateAllFormFields(this.form)
            }

        }
    }
    changePicUrl(){
        const currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (currentUser ) {
            /*       this.picture = currentUser.picture;
                   this.fullurl = this.imgUrl+'upload/'+this.picture*/;
            this.fullurl = this.imgUrl+'upload/'+currentUser.picture;
        }
    }
    updatePassword() {
        /* if(this.modelName === 'years') {
             item.id = item.year;
         }

         if (item) {
             this.router.navigate(['/'+this.modelName+'/edit', item.id]);
         }*/
        // this.router.navigate(['/users/profile']);
        const modalRef = this.modalService.open(UserProfileComponent);
        modalRef.componentInstance.refShow = this.refShow;
        modalRef.componentInstance.rowId = '';

    }
    changePicture() {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                this.changePicUrl();

                console.log("before dismiss");
                //
                return true;
            }
        };
        const modalRef = this.modalService.open(UserPictureComponent,options);
        modalRef.componentInstance.refShow = this.refShow;
        modalRef.componentInstance.rowId = '';

    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({onlySelf: true});
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    close() {
        this.changePicUrl();
        this.activeModal.dismiss('done');
    }

    restoreLog(log: Log) {
        const options: NgbModalOptions = {

            beforeDismiss: () => {
                this.changePicUrl();

                console.log("before dismiss");
                //
                return true;
            }
        };
        this.modalRef = this.modalService.open(this.refShow, options);
        this.modalRef.result.then(() => {
            this.activeModal.dismiss('done');
        }, () => {
            console.log('Backdrop click')
        });
        this.modalRef.componentInstance.oldData = log.old;
        this.modalRef.componentInstance.newData = log.new;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/user-settings/user-settings.component.ts